import { Component } from '@angular/core';
import { LoadingService } from './loading.service';
import { Router } from '@angular/router';
var LoadingComponent = /** @class */ (function () {
    function LoadingComponent(service, router) {
        this.service = service;
        this.router = router;
        this.is_loading = false;
    }
    LoadingComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.service.observable.subscribe(function (loading) {
            _this.is_loading = loading;
        });
    };
    LoadingComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    LoadingComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'loading',
                    template: "<div *ngIf=\"is_loading\" class=\"loadingArea loadingWrapper\">\n  <div class=\"loadingWrapper_content\">\n    <p><img src=\"img/loading.gif\"></p>\n  </div>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    LoadingComponent.ctorParameters = function () { return [
        { type: LoadingService },
        { type: Router }
    ]; };
    return LoadingComponent;
}());
export { LoadingComponent };
//# sourceMappingURL=loading.component.js.map